import "@/providers/i18n";
import "@/providers/dates";

import AnalyticsProvider from "@/providers/Analytics";
import ApiProvider from "@/providers/Api";
import RouterProvider from "@/providers/Router";
import UiProvider from "@/providers/Ui";
import WhitelabelBrandProvider from "@/providers/WhitelabelBrand";
import { useCookieBanner } from "@/utils/cookieBanner";

import type { PropsWithChildren } from "react";

const AppLayerRouter = () => {
  return <RouterProvider />;
};

const AppLayerApi = ({ children }: PropsWithChildren) => {
  return <ApiProvider>{children}</ApiProvider>;
};

const AppLayerUI = ({ children }: PropsWithChildren) => {
  return <UiProvider>{children}</UiProvider>;
};

const AppLayerWhitelabel = ({ children }: PropsWithChildren) => {
  return <WhitelabelBrandProvider>{children}</WhitelabelBrandProvider>;
};

const AppLayerAnalytics = ({ children }: PropsWithChildren) => {
  return <AnalyticsProvider>{children}</AnalyticsProvider>;
};

// Note: AppLayerAuth / AuthProvider is used in RootRoute (__root.tsx)

const App = () => {
  useCookieBanner();
  return (
    <AppLayerAnalytics>
      <AppLayerWhitelabel>
        <AppLayerUI>
          <AppLayerApi>
            <AppLayerRouter />
          </AppLayerApi>
        </AppLayerUI>
      </AppLayerWhitelabel>
    </AppLayerAnalytics>
  );
};

export default App;
